import { i18n } from '@/packages/i18n';
import { nextTick } from 'vue';
import { useGlobalStore } from '@/stores/globalStore';

export const LOCALES = [
  {
    name: 'Czech',
    value: 'cs',
  },
  {
    name: 'Danish',
    value: 'da',
  },
  {
    name: 'German',
    value: 'de',
  },
  {
    name: 'Greek',
    value: 'el',
  },
  {
    name: 'English',
    value: 'en',
  },
  {
    name: 'Spanish',
    value: 'es',
  },
  {
    name: 'French',
    value: 'fr',
  },
  {
    name: 'Italian',
    value: 'it',
  },
  {
    name: 'Japanese',
    value: 'ja',
  },
  // {
  //   name: 'Korean',
  //   value: 'ko',
  // },
  {
    name: 'Lithuanian',
    value: 'lt',
  },
  {
    name: 'Dutch',
    value: 'nl',
  },
  {
    name: 'Polish',
    value: 'pl',
  },
  {
    name: 'Portuguese',
    value: 'pt',
  },
  {
    name: 'Turkish',
    value: 'tr',
  },
  {
    name: 'Vietnamese',
    value: 'vi',
  },
  {
    name: 'Chinese (traditional, Hong Kong)',
    value: 'hk',
  },
  {
    name: 'Chinese (simplified)',
    value: 'zh',
  },
];

/**
 * Get Supported Locales
 *
 * @returns {array} supported locales
 */
const supportedLocales = () => LOCALES.map((locale) => locale.value);

/**
 * Set Current Locale
 */
const setCurrentLocale = (newLocale) => {
  i18n.global.locale.value = newLocale;
};

const getBrowserLocale = () => navigator.language?.split('-')[0]?.toLowerCase();

export const getPersistedLocale = () => {
  const persistedLocale = JSON.parse(localStorage.getItem('locale'));

  if (supportedLocales().some((locale) => locale === persistedLocale)) {
    return persistedLocale;
  }

  // First visit: prefer the browser language when we ship that locale.
  const browserLocale = getBrowserLocale();

  if (supportedLocales().some((locale) => locale === browserLocale)) {
    return browserLocale;
  }

  return 'en';
};

export const selectedLocale = () => LOCALES.find((locale) => locale.value === getPersistedLocale());

/**
 * Load Locale Messages
 */
export const loadLocaleMessages = async (locale = 'en') => {
  try {
    const messages = await import(`./locales/${locale.toLowerCase()}.json`);
    i18n.global.setLocaleMessage(locale, messages.default);
    return nextTick();
  } catch (error) {
    console.error(error);
  }
  return null;
};

/**
 * Switch Locale
 */
export const switchLanguage = async (newLocale) => {
  const globalStore = useGlobalStore();
  await loadLocaleMessages(newLocale);
  setCurrentLocale(newLocale);
  globalStore.setLanguage(newLocale);
};
